import { prop, required } from '@rxweb/reactive-form-validators';

export class Address {
  @prop()
  hasNoNumber?: boolean;

  @prop()
  @required()
  zipCode?: string;

  @prop()
  @required()
  street?: string;

  @prop()
  @required()
  number?: string;

  @prop()
  complement?: string;

  @prop()
  @required()
  district?: string;

  @prop()
  @required()
  state?: string;

  @prop()
  @required()
  city?: string;

  @prop()
  correspondenceAddress?: boolean;
}
